import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

// apicore
import { APICore, setAuthorization } from '../../helpers/api/apiCore';

// helpers
import {
    login as loginApi,
    loginWithCode as loginWithCodeApi,
    logout as logoutApi,
    signup as signupApi,
    forgotPassword as forgotPasswordApi,
} from '../../helpers/';

// actions
import { authApiResponseSuccess, authApiResponseError } from './actions';

// constants
import { AuthActionTypes } from './constants';
//import { message } from 'antd';

interface UserData {
    payload: {
        username: string;
        password: string;
        fullname: string;
        email: string;
        code:string;
    };
    type: string;
}

const api = new APICore();

/**
 * Login the user
 * @param {*} payload - username and password
 */
function* login({ payload: { email, password }, type }: UserData): SagaIterator {
    try {
        const response = yield call(loginApi, { email, password });
        if(response?.data===undefined)
        {
            yield put(authApiResponseError(AuthActionTypes.LOGIN_USER,"خطایی رخ داده است" , "500"));
        }
        else
        if(response?.data?.isOPT !==undefined && response?.data?.isOPT===true)
        {
            yield put(authApiResponseSuccess(AuthActionTypes.OPT_USER, {}, response?.data?.phoneNumber));
        }
        else
        if (!response.data.message || response.data.message === '') {
            const user = response.data;
            // NOTE - You can change this according to response format from your api
            api.setLoggedInUser(user.access_token);
            setAuthorization(user.access_token);
            const userDetail = api.getLoggedInUser()
            const s_userDetails={userId:userDetail.nameid,userName:userDetail.unique_name,fullName:userDetail.fullName,mobile:userDetail.mobile,lastLogin:userDetail.lastLoginInfo,role:userDetail.role, defaultPage:userDetail.defaultPage, isOptLogin:userDetail.isOptLogin}
            yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user.access_token, s_userDetails));
        }
        else {            
            yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, response.data.message, response.data.statusCode));
        }

    } catch (error: any) {
        yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, error));
        api.setLoggedInUser(null);
        setAuthorization(null);
    }
}

function* loginWithCode({ payload: { email, password, code }, type }: UserData): SagaIterator {
    try {
        const response = yield call(loginWithCodeApi, { email, password,code });                
        if (!response.data.message || response.data.message === '') {
            const user = response.data;
            // NOTE - You can change this according to response format from your api
            api.setLoggedInUser(user.access_token);
            setAuthorization(user.access_token);
            const userDetail = api.getLoggedInUser()
            const s_userDetails={userId:userDetail.nameid,userName:userDetail.unique_name,fullName:userDetail.fullName,mobile:userDetail.mobile,lastLogin:userDetail.lastLoginInfo,role:userDetail.role, defaultPage:userDetail.defaultPage,isOptLogin:userDetail.isOptLogin}
            yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user.access_token, s_userDetails));
        }
        else {            
            yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, response.data.message, response.data.statusCode));
        }

    } catch (error: any) {
        yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, error));
        api.setLoggedInUser(null);
        setAuthorization(null);
    }
}

/**
 * Logout the user
 */
function* logout(): SagaIterator {
    try {
        //yield call(logoutApi);
        const response = yield call(logoutApi);
        api.setLoggedInUser(null);
        setAuthorization(null);
        yield put(authApiResponseSuccess(AuthActionTypes.LOGOUT_USER, {},{}));
    } catch (error: any) {
        yield put(authApiResponseError(AuthActionTypes.LOGOUT_USER, error));
    }
}

function* signup({ payload: { fullname, email, password } }: UserData): SagaIterator {
    try {
        const response = yield call(signupApi, { fullname, email, password });
        const user = response.data;
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(authApiResponseSuccess(AuthActionTypes.SIGNUP_USER, user));
    } catch (error: any) {
        yield put(authApiResponseError(AuthActionTypes.SIGNUP_USER, error));
        api.setLoggedInUser(null);
        setAuthorization(null);
    }
}

function* forgotPassword({ payload: { email } }: UserData): SagaIterator {
    try {
        const response = yield call(forgotPasswordApi, { email });
        yield put(authApiResponseSuccess(AuthActionTypes.FORGOT_PASSWORD, response.data));
    } catch (error: any) {
        yield put(authApiResponseError(AuthActionTypes.FORGOT_PASSWORD, error));
    }
}
export function* watchLoginUser() {
    yield takeEvery(AuthActionTypes.LOGIN_USER, login);
}

export function* watchLoginUserWithCode() {
    yield takeEvery(AuthActionTypes.LOGIN_USER_WITH_CODE, loginWithCode);
}

export function* watchLogout() {
    
    yield takeEvery(AuthActionTypes.LOGOUT_USER, logout);
}

export function* watchSignup(): any {
    yield takeEvery(AuthActionTypes.SIGNUP_USER, signup);
}

export function* watchForgotPassword(): any {
    yield takeEvery(AuthActionTypes.FORGOT_PASSWORD, forgotPassword);
}

function* authSaga() {
    yield all([fork(watchLoginUser),fork(watchLoginUserWithCode), fork(watchLogout), fork(watchSignup), fork(watchForgotPassword)]);
}

export default authSaga;
